module.exports = __webpack_public_path__ + "static/media/arrowUp.5cccc185.svg";